<div class="min-h-screen flex flex-col">
  <header class="bg-gray-100 flex flex-row justify-between p-4 pb-0">
    <div>
      @if (currentUrl() !== '/' && currentUrl() !== '') {
      <a [routerLink]="['/']" (click)="confirmExit($event)"
        ><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path fill="currentColor" d="M10 22L0 12L10 2l1.775 1.775L3.55 12l8.225 8.225z" /></svg
      ></a>
        }
    </div>
    <div>
      <h1 class="text-3xl font-bold">{{ title }}</h1>
      <p class="text-gray-400 font-light text-end">{{ client }}</p>
    </div>
  </header>
  <main class="bg-gray-100 flex-1">
    <ng-content></ng-content>
  </main>
</div>
